export enum DataStatus {
    Updated = 'updated',
    Error = 'error',
    Unchanged = 'unchanged'
}
